import { useEffect, useState } from 'react';

import { BugTracker } from 'kb-shared/utilities/bugTracker';

// S3 serves uploaded SVGs as application/octet-stream, which <img> refuses to render,
// so the file is fetched and re-wrapped in a Blob with the correct MIME type.
export const useSvg = (svgUrl: string | null | undefined) => {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!svgUrl) return;

    const controller = new AbortController();
    let createdUrl: string | null = null;

    fetch(svgUrl, { signal: controller.signal })
      .then(res => {
        if (!res.ok) throw new Error(`Failed to load SVG: HTTP ${res.status}`);
        return res.text();
      })
      .then(text => {
        createdUrl = URL.createObjectURL(new Blob([text], { type: 'image/svg+xml' }));
        setObjectUrl(createdUrl);
      })
      .catch(error => {
        // Aborts and network errors (offline, tab frozen, page unload) are transient;
        // the default icon is shown instead.
        if (controller.signal.aborted || error instanceof TypeError) return;
        BugTracker.notify(error, 'Failed to load SVG');
      });

    return () => {
      controller.abort();
      if (createdUrl) URL.revokeObjectURL(createdUrl);
      setObjectUrl(null);
    };
  }, [svgUrl]);

  return objectUrl;
};
